import { combineReducers } from 'redux';
import { CAR_LIST, FILTER_CARS } from './actionTypes';
import util from '../util';

export default combineReducers({
  carList: util.requestReducer(CAR_LIST),
  filteredCars: util.requestReducer(FILTER_CARS),
});
